import { Component, computed, inject, OnInit, signal } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { IncompleteDataRequestsService } from "./incomplete-data-requests.service";
import { IncompleteDataAccessRequest } from "./incomplete-data-access-request";
import { MessagesModule } from "primeng/messages";
import { Message } from "primeng/api";
import { DatePipe } from "@angular/common";
import { PanelModule } from "primeng/panel";
import { UserHelperService } from "@main/users/user-helper.service";
import { Router } from "@angular/router";

@Component({
    selector: "incomplete-data-prompt",
    standalone: true,
    imports: [DialogModule, ButtonModule, MessagesModule, DatePipe, PanelModule],
    providers: [IncompleteDataRequestsService],
    templateUrl: "./incomplete-data-prompt.component.html"
})
export class IncompleteDataPromptComponent implements OnInit {
    private readonly requestsService = inject(IncompleteDataRequestsService);
    private readonly userHelperService = inject(UserHelperService);
    private readonly router = inject(Router);

    protected readonly promptsPending = signal([] as IncompleteDataAccessRequest[]);
    protected readonly visible = signal(false);
    protected readonly info = computed(() => {
        const plural = this.promptsPending().length > 1;
        return [
            {
                severity: "info",
                detail: `There ${plural ? "are" : "is a"} new ORB Data Access request${plural ? "s" : ""} for you to review`
            } as Message
        ];
    });
    protected grantingOrMarking = signal(false);

    async ngOnInit() {
        if (!this.userHelperService.isPatient) {
            return;
        }

        const prompts = await this.requestsService.getPatientPrompts();
        this.promptsPending.update(_ => prompts);
        this.visible.set(prompts.length > 0);
    }

    protected async grantAccess() {
        this.grantingOrMarking.set(true);
        await this.requestsService.grantManualAccessAll();
        this.visible.set(false);
    }

    protected async reviewLater() {
        this.grantingOrMarking.set(true);
        await this.requestsService.markPatientPrompts();
        this.visible.set(false);
    }

    protected manage() {
        this.requestsService.markPatientPrompts();
        this.visible.set(false);
        return this.router.navigateByUrl("/app/profile/data-sharing");
    }
}
